import 'moment/locale/ca';
import 'moment/locale/es';
import 'moment/locale/it';
import 'moment/locale/pt';
import 'moment/locale/fr';
import 'moment/locale/de';

import { initReactI18next } from 'react-i18next';
import { isDevelopmentMode } from '@utils/get-environment/get-environment';
import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import backend from 'i18next-http-backend';
import moment from 'moment-timezone';

import packageJson from '../package.json';

if (typeof window !== 'undefined' && import.meta.env.MODE !== 'production') {
  window.moment = moment;
}

const appVersion = packageJson.version;

i18n
  .use(backend)
  .use(detector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['ca', 'de', 'en', 'es', 'fr', 'it', 'pt'],
    debug: isDevelopmentMode,
    ns: [
      'common',
      'customers',
      'floorplan',
      'eventInfo',
      'eventList',
      'eventDetails',
      'offers',
      'publish',
      'menu',
      'errors',
      'addons',
      'presets',
      'passes',
      'analytics',
      'invitations',
      'eventReport',
      'bookingDetail',
      'selectVenue',
      'refundModal',
      'viewOnlyReportPage',
      'preRegistration',
      'userPermissions',
      'userManagement',
      'companySettings',
      'companyIntegrations',
      'companyWidget',
    ],

    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['querystring', 'navigator'],
    },
    react: {
      useSuspense: false,
    },
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?lng={{lng}}&{{ns}}&v=${appVersion}`,
      requestOptions: {
        cache: 'no-store',
      },
    },
  });

export default i18n;
